'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MINUTE_MS = exports.MINUTE_MS = 60 * 1000;
var HOUR_MS = exports.HOUR_MS = MINUTE_MS * 60;
var DAY_MS = exports.DAY_MS = HOUR_MS * 24;
var DAY_MAP_EN = exports.DAY_MAP_EN = 'Sun Mon Tue Wed Thur Fri Sat'.split(' ');
var DAY_MAP_LONG_EN = exports.DAY_MAP_LONG_EN = 'Sunday Monday Tuesday Wednesday Thursday Friday Saturday'.split(' ');